import { useMutation } from '@tanstack/react-query';

import { prophetTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const cloneProphetPage: prophetTypes.CloneProphetPage = (data) => {
  return axios.post(`/prophet/pages/clone`, data);
};

type CloneProphetPageOptions = {
  pageId: string;
  config?: MutationConfig<typeof cloneProphetPage>;
};

export function useCloneProphetPage({ config = {}, pageId }: CloneProphetPageOptions) {
  return useMutation({
    ...config,
    mutationFn: cloneProphetPage,
    onSuccess: (...args) => {
      queryClient.refetchQueries(['prophet-rules', pageId]);
      // Cloning writes a 'clone' audit record on the target page, same as the
      // edit/toggle mutations do.
      queryClient.invalidateQueries(['prophet-page-audit']);
      config.onSuccess && config.onSuccess(...args);
    },
  });
}
